import { IconProps } from '../icon';

export function ItaliqueIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 205.38 255.41"
      {...props}
    >
      <g id="a" />
      <g id="b">
        <g id="c">
          <path d="M117.25,230.52v24.89H0v-24.8c1.92,0,3.7,0,5.48,0,13.17,0,26.35-.17,39.51,.1,3.89,.08,5.42-1.37,6.72-4.81,20.94-55.19,42-110.33,63.05-165.47,3.79-9.94,7.63-19.87,11.42-29.81,.64-1.67,1.18-3.38,2.02-5.8h-40.07V0h117.26V24.7c-1.81,0-3.56,0-5.31,0-13.34,0-26.68,.11-40.01-.08-3.31-.05-5.01,.85-6.23,4.07-24.98,65.75-50.08,131.45-75.13,197.17-.51,1.34-.81,2.77-1.35,4.66h39.91Z" />
        </g>
      </g>
    </svg>
  );
}

export default ItaliqueIcon;
